export const pricelist = {
    USD: {
        Basic: {
            trial: 14,
            price: 15,
            stripePlanID: 1,
            planid: '1'
        },
        Standard: {
            trial: 7,
            price: 50,
            stripePlanID: 1,
            planid: '3'
        },
        Agency: {
            _10000: {
                trial: 7,
                price: 75,
                stripePlanID: 1,
                planid: '98701'
            },
            _25000: {
                trial: 7,
                price: 100,
                stripePlanID: 1,
                planid: '98702'
            },
            _50000: {
                trial: 7,
                price: 150,
                stripePlanID: 1,
                planid: '98703'
            },
            _75000: {
                trial: 7,
                price: 200,
                stripePlanID: 1,
                planid: '98704'
            },
            _100000: {
                trial: 7,
                price: 250,
                stripePlanID: 1,
                planid: '98705'
            },
        }
    },
    GBP: {
        Basic: {
            trial: 14,
            price: 12,
            stripePlanID: 1,
            planid: '201'
        },
        Standard: {
            trial: 7,
            price: 40,
            stripePlanID: 1,
            planid: '200'
        },
        Agency: {
            _10000: {
                trial: 7,
                price: 60,
                stripePlanID: 1,
                planid: '98711'
            },
            _25000: {
                trial: 7,
                price: 80,
                stripePlanID: 1,
                planid: '98712'
            },
            _50000: {
                trial: 7,
                price: 120,
                stripePlanID: 1,
                planid: '98713'
            },
            _75000: {
                trial: 7,
                price: 160,
                stripePlanID: 1,
                planid: '98714'
            },
            _100000: {
                trial: 7,
                price: 200,
                stripePlanID: 1,
                planid: '98715'
            },
        }
    },
    EUR: {
        Basic: {
            trial: 14,
            price: 13,
            stripePlanID: 1,
            planid: '302'
        },
        Standard: {
            trial: 7,
            price: 45,
            stripePlanID: 1,
            planid: '301'
        },
        Agency: {
            _10000: {
                trial: 7,
                price: 69,
                stripePlanID: 1,
                planid: '98716'
            },
            _25000: {
                trial: 7,
                price: 90,
                stripePlanID: 1,
                planid: '98717'
            },
            _50000: {
                trial: 7,
                price: 135,
                stripePlanID: 1,
                planid: '98718'
            },
            _75000: {
                trial: 7,
                price: 180,
                stripePlanID: 1,
                planid: '98719'
            },
            _100000: {
                trial: 7,
                price: 225,
                stripePlanID: 1,
                planid: '98720'
            },
        }
    },
    AUD: {
        Basic: {
            trial: 14,
            price: 25,
            stripePlanID: 1,
            planid: '402'
        },
        Standard: {
            trial: 7,
            price: 75,
            stripePlanID: 1,
            planid: '401'
        },
        Agency: {
            _10000: {
                trial: 7,
                price: 115,
                stripePlanID: 1,
                planid: '98721'
            },
            _25000: {
                trial: 7,
                price: 150,
                stripePlanID: 1,
                planid: '98722'
            },
            _50000: {
                trial: 7,
                price: 225,
                stripePlanID: 1,
                planid: '98723'
            },
            _75000: {
                trial: 7,
                price: 300,
                stripePlanID: 1,
                planid: '98724'
            },
            _100000: {
                trial: 7,
                price: 375,
                stripePlanID: 1,
                planid: '98725'
            },
        }
    }
}